import type { UserNextStep } from "@/Modules/Models/Domain/User";

import { getNextSteps } from "@/Services/TherapyApi/Users";

import useUserStore from "../Store";

import UserNextStepTransformer from "@/Modules/Transformers/User/UserNextStep";

import { hasValue } from "@/Utils/Objects";

async function getNextStepsAH(): Promise<UserNextStep[]> {
  const userStore = useUserStore();

  if (hasValue(userStore.user) && userStore.getUserIsPatient) {
    const steps = await getNextSteps();

    return steps.map((step) => UserNextStepTransformer.toDomain(step));
  }

  return [];
}

export default getNextStepsAH;
